import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedLink,
} from '../../components';
import handOne from '../AboutPage/images/handOne.png';
import hiFive from '../AboutPage/images/hi5.png';
import CookieBlockedIframe from '../../components/CookieBlockedIframe/CookieBlockedIframe';
import css from './VideoAboutPage.module.css';

const VideoAboutPage = () => {
  // prettier-ignore
  return (
    <StaticPage
      title="How to book"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description:
          'How to make a video booking for deaf users',
        name: 'Video About Page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
         <div className={css.contentWrapper}>
          <h1 className={css.pageTitle}>Video service for Deaf users</h1>
          <section id="about" className={css.intro}>
                  
               
          <div className={css.videoSection}>
            <div className={css.videoContainer}>
              <CookieBlockedIframe
                src="https://www.youtube-nocookie.com/embed/QQnZwHQaCXM?rel=0&origin=https://signalise.coop"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="embedded YouTube clip of a BSL translation"
              />
            </div>
          </div>
        </section>
       <div className={css.contentContainer}>
            <div className={css.contentSide}>
              <img src={hiFive} alt="Two Signalise hands happy" className={css.hiFive} />
              <img src={handOne} className={css.hand} alt="hand smiling"></img>
            </div>
            <div className={css.contentMain}> 
            <p>Welcome to the Signalise Co-op Video Service which you can use to call your doctor, other NHS services or for calls for work or at home. We will be adding more organisations.</p>
                  <h2>1: Create an account</h2>
                  <p>You can sign up for your account  <a href="https://signalise.coop/signup">here.</a></p>
                
                <div>
                    <h2>2: To make a call</h2>
                    <p>Click 'Create a video call'. This is at the top of the page in the green menu or click the button below.</p> 
                </div>
                <div>
                  <h2>3: Who are you calling?</h2>
                  <p>From the drop down list, click the name of the organisation you want to call.</p>
                </div>
                <div>
                  <h2>4: Add any details you want us to know:</h2>
                  <p>Give us more information about the call e.g. Only want a female interpreter?</p>
                </div>
                <div>
                  <h2>5: Call Confirmed</h2>
                  <p>Click the confirmation link to join the call.</p>
                  <p> You will also receive an email of the link.</p>
                </div>
                    <NamedLink name="DeafUserVideoAccessPage" className={css.bookingButton}>
                      Make a call
                    </NamedLink>  
                  </div>
                </div>
              </div> 
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default VideoAboutPage;
